import { render } from "./Uitvaart.vue?vue&type=template&id=b21ba6d2"
import script from "./Uitvaart.vue?vue&type=script&lang=js"
export * from "./Uitvaart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__